import "core-js/modules/es6.array.find.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { LOCALES, DEFAULT_LOCALE } from '~/const/i18n';
import { NEW_RELIC_SCRIPT_SET } from '~/store/modules/script/types';
export default {
  nuxtServerInit: function nuxtServerInit(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, dispatch, params, req, response, locale, protocol, baseURL;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, dispatch = _ref.dispatch;
              params = _ref2.params, req = _ref2.req;
              _context.next = 4;
              return _this.$axios.post('/new-relic/script', {});

            case 4:
              response = _context.sent;
              if (response && response.data && response.data.newRelicScript) commit(NEW_RELIC_SCRIPT_SET, response.data.newRelicScript);
              dispatch('detectSearchEngine', req.headers['user-agent']);
              locale = LOCALES.filter(function (obj) {
                return obj.market === params.market;
              }).find(function (obj) {
                return obj.language === params.language;
              }) || DEFAULT_LOCALE;
              commit('i18n/SET_LOCALE', locale);
              _this.app.i18n.locale = locale.language;
              protocol = 'http';

              if (req && req.headers && req.headers['x-forwarded-proto']) {
                protocol = req.headers['x-forwarded-proto'];
              }

              baseURL = req ? "".concat(protocol, "://").concat(req.headers.host) : '';
              commit('request/SET_BASE_URL', baseURL); // fetch mainHeader navigation

              _context.next = 16;
              return dispatch('navigationBar/navigationBarContent', {});

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};